var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "app-container bj-label-colon label-width-7 bj-el-input-disabled app-container-2022-2-9-11-42-08",
    },
    [
      _c("div", { staticClass: "tabs isFixed" }, [
        _c(
          "div",
          { staticClass: "tabs-btn" },
          [
            _vm.$route.query.type == "edit" &&
            _vm.routeStatus === 4 &&
            ![0, 2, 3, 5].includes(_vm.routeOrderHandleStatus) &&
            !_vm.isUrgent &&
            _vm.$route.query.tabName != "waitHunter"
              ? _c(
                  "el-button",
                  {
                    attrs: {
                      disabled: _vm.suspendStatus == "21201",
                      type: "primary",
                    },
                    on: { click: _vm.onEditOrder },
                  },
                  [_vm._v(_vm._s(_vm.$t("editText")))]
                )
              : _vm._e(),
            (_vm.orderInfoVO.orderStatus == 0 ||
              _vm.orderInfoVO.orderStatus == 3) &&
            (_vm.orderInfoVO.sapOrderStatus != 1 ||
              _vm.orderInfoVO.sapOrderStatus != 2) &&
            _vm.routeStatus === 4 &&
            ![0, 2, 3, 5].includes(_vm.routeOrderHandleStatus) &&
            !_vm.isUrgent &&
            _vm.$route.query.tabName != "waitHunter"
              ? _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.onCancel } },
                  [_vm._v(_vm._s(_vm.$t("InternalSalesOrderDetails.Cancel")))]
                )
              : _vm._e(),
            _vm.routeOrderHandleStatus !== 0
              ? _c("BjLogButton", {
                  attrs: {
                    type: "order",
                    "default-query": {
                      innerOrderNo: _vm.orderInfoVO.innerOrderNo,
                      copyOrigin: _vm.orderInfoVO.copyOrigin,
                      isUser: false,
                      isVisible: [10, 11].includes(_vm.$store.getters.tenantId)
                        ? 1
                        : null,
                    },
                    "no-permission": "",
                    title: _vm.orderInfoVO.innerOrderNo,
                    api: "orderApi",
                  },
                })
              : _vm._e(),
            _c("el-button", { on: { click: _vm.handleClose } }, [
              _vm._v(_vm._s(_vm.$t("backText"))),
            ]),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "tabs", class: { isFixed2: _vm.isFixed } },
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.tabClick },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            _vm._l(_vm.catalogue, function (item) {
              return _c("el-tab-pane", {
                key: item.id,
                attrs: { label: item.name, name: item.id },
              })
            }),
            1
          ),
        ],
        1
      ),
      _c("div", {
        staticClass: "placeholder-tabs",
        attrs: { id: "placeholderTabs" },
      }),
      _c(
        "BjDivider",
        {
          attrs: { id: "orderInfo", "right-fixed": "" },
          scopedSlots: _vm._u([
            {
              key: "right",
              fn: function () {
                return undefined
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(
            _vm._s(this.$t("InternalSalesOrderDetails.Orderinformation")) + " "
          ),
        ]
      ),
      _vm.orderInfoVO.tags
        ? _c(
            "div",
            { staticClass: "bj-row mt20 tags" },
            [
              _c("BjTagList", {
                attrs: { "tag-code-array": _vm.cptOrderTagCodeList },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "bj-row mt20 padding-no fix" },
        [
          _c(
            "div",
            { staticClass: "bj-col bj-col-12" },
            [
              _c("div", { staticClass: "bj-form-title" }, [
                _vm._v(
                  " " + _vm._s(_vm.$t("InternalSalesOrderDetails.Basic")) + " "
                ),
                _vm.operationType == 1
                  ? _c(
                      "span",
                      {
                        staticClass: "link right",
                        on: { click: _vm.onEditAbnormal },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("InternalOrder.form.AbnormalCause"))
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "bj-form-item" }, [
                _c("div", { staticClass: "bj-formItemLabel" }, [
                  _vm._v(_vm._s(_vm.$t("InternalSalesOrderDetails.type"))),
                ]),
                _c("div", { staticClass: "bj-form-item-value" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          _vm.ORDER_BUSINESS_TYPE_LIST.bjGet(
                            _vm.orderInfoVO.businessType
                          )
                        )
                      ) +
                      " "
                  ),
                ]),
              ]),
              _c("div", { staticClass: "bj-form-item" }, [
                _c("div", { staticClass: "bj-formItemLabel" }, [
                  _vm._v(_vm._s(_vm.$t("InternalSalesOrderDetails.Order"))),
                ]),
                _c("div", { staticClass: "bj-form-item-value" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          _vm.ORDER_INTERNAL_ALL_STATUS_LIST.bjGet(
                            _vm.totalOrderStatus
                          )
                        )
                      ) +
                      " "
                  ),
                ]),
              ]),
              _c("div", { staticClass: "bj-form-item" }, [
                _c("div", { staticClass: "bj-formItemLabel" }, [
                  _vm._v(_vm._s(_vm.$t("InternalSalesOrderDetails.party"))),
                ]),
                _c(
                  "div",
                  { staticClass: "bj-form-item-value" },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "link",
                        on: {
                          click: function ($event) {
                            return _vm.$toBusinessThirdOrderView(
                              _vm.orderInfoVO.outerOrderNo
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.orderInfoVO.webReference))]
                    ),
                    _c("BjCopyIcon", {
                      attrs: { copy: _vm.orderInfoVO.webReference },
                    }),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "bj-form-item" }, [
                _c("div", { staticClass: "bj-formItemLabel" }, [
                  _vm._v(_vm._s(_vm.$t("InternalOrder.form.wmsOrderNo"))),
                ]),
                _c(
                  "div",
                  { staticClass: "bj-form-item-value" },
                  [
                    _c("span", [_vm._v(_vm._s(_vm.orderInfoVO.sapOrderNo))]),
                    _c("BjCopyIcon", {
                      attrs: { copy: _vm.orderInfoVO.sapOrderNo },
                    }),
                  ],
                  1
                ),
              ]),
              _vm.orderInfoVO.storeCode == "CO00000658"
                ? _c("div", { staticClass: "bj-form-item" }, [
                    _c("div", { staticClass: "bj-formItemLabel" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("DetailsOfThirdPartySalesOrder.dodgeCompany")
                        )
                      ),
                    ]),
                    _c("div", { staticClass: "bj-form-item-value" }, [
                      _vm._v(_vm._s(_vm.orderInfoVO.ecommerceOrderRef)),
                    ]),
                  ])
                : _vm._e(),
              _vm.orderInfoVO.storeCode == "CO00000658"
                ? _c("div", { staticClass: "bj-form-item" }, [
                    _c("div", { staticClass: "bj-formItemLabel" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("DetailsOfThirdPartySalesOrder.dodgeAccount")
                        )
                      ),
                    ]),
                    _c("div", { staticClass: "bj-form-item-value" }, [
                      _vm._v(_vm._s(_vm.orderInfoVO.siteListingId)),
                    ]),
                  ])
                : _vm._e(),
              _c("div", { staticClass: "bj-form-item" }, [
                _c("div", { staticClass: "bj-formItemLabel" }, [
                  _vm._v(_vm._s(_vm.$t("InternalSalesOrderDetails.Store"))),
                ]),
                _c("div", { staticClass: "bj-form-item-value" }, [
                  _vm._v(" " + _vm._s(_vm.orderInfoVO.storeName) + " "),
                  _c("span", { staticClass: "F68710" }, [
                    _vm._v(
                      "（" +
                        _vm._s(
                          _vm.SCHL_CHANNEL_TYPE.bjGet(_vm.orderInfoVO.channel)
                        ) +
                        "）"
                    ),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "bj-form-item" }, [
                _c("div", { staticClass: "bj-formItemLabel" }, [
                  _vm._v(_vm._s(_vm.$t("InternalSalesOrderDetails.Three"))),
                ]),
                _c("div", { staticClass: "bj-form-item-value" }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("timeFilters")(
                        _vm.orderInfoVO.orderTime,
                        _vm.orderInfoVO.orderTime
                      )
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "bj-form-item" }, [
                _c("div", { staticClass: "bj-formItemLabel" }, [
                  _vm._v(_vm._s(_vm.$t("InternalSalesOrderDetails.creation"))),
                ]),
                _c("div", { staticClass: "bj-form-item-value" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm._f("timeOperateTwoHour")(
                          _vm.orderInfoVO.creationDate
                        )
                      ) +
                      " "
                  ),
                ]),
              ]),
              _vm.orderInfoVO.shippingMethod === "CSG MANUAL"
                ? _c("div", { staticClass: "bj-form-item" }, [
                    _c("div", { staticClass: "bj-formItemLabel" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "BusinessThirdOrderAdd.deliveryAppointmentTime"
                          )
                        )
                      ),
                    ]),
                    _c("div", { staticClass: "bj-form-item-value" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("timeFilters")(
                              _vm.orderInfoVO.deliveryAppointmentTime,
                              _vm.orderInfoVO.deliveryAppointmentTime
                            )
                          ) +
                          " "
                      ),
                    ]),
                  ])
                : _vm._e(),
              _c("div", { staticClass: "bj-form-item" }, [
                _c("div", { staticClass: "bj-formItemLabel" }, [
                  _vm._v(_vm._s(_vm.$t("InternalSalesOrderDetails.Merchant"))),
                ]),
                _c(
                  "div",
                  { staticClass: "bj-form-item-value order-remark-content" },
                  [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          effect: "dark",
                          content: _vm.orderInfoVO.orderRemarks,
                          disabled: !_vm.orderInfoVO.orderRemarks,
                          placement: "top-start",
                          "popper-class": "csg-order-remark-tooltip",
                        },
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "ellipsis order-remark-text" },
                          [_vm._v(_vm._s(_vm.orderInfoVO.orderRemarks))]
                        ),
                      ]
                    ),
                    _vm.orderInfoVO.orderRemarks
                      ? _c("BjCopyIcon", {
                          staticClass: "link order-remark-copy",
                          attrs: { copy: _vm.orderInfoVO.orderRemarks },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                [7, 8].includes(_vm.routeStatus)
                  ? _c(
                      "div",
                      {
                        staticClass: "bj-form-item-right link",
                        staticStyle: { "font-size": "14px" },
                        on: {
                          click: function ($event) {
                            return _vm.onEditRemarks("orderRemarks")
                          },
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("InternalSalesOrderDetails.Modify"))
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "bj-form-item" }, [
                _c("div", { staticClass: "bj-formItemLabel" }, [
                  _vm._v(_vm._s(_vm.$t("InternalSalesOrderDetails.Customer"))),
                ]),
                _c(
                  "div",
                  { staticClass: "bj-form-item-value order-remark-content" },
                  [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          effect: "dark",
                          content: _vm.orderInfoVO.serviceRemarks,
                          disabled: !_vm.orderInfoVO.serviceRemarks,
                          placement: "top-start",
                          "popper-class": "csg-order-remark-tooltip",
                        },
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "ellipsis order-remark-text" },
                          [_vm._v(_vm._s(_vm.orderInfoVO.serviceRemarks))]
                        ),
                      ]
                    ),
                    _vm.orderInfoVO.serviceRemarks
                      ? _c("BjCopyIcon", {
                          staticClass: "link order-remark-copy",
                          attrs: { copy: _vm.orderInfoVO.serviceRemarks },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
              _vm.orderInfoVO.shippingMethod === "CUSTOMER MANUAL" &&
              _vm.operationType == 1 &&
              _vm.routeStatus !== 3
                ? _c("div", { staticClass: "bj-form-item" }, [
                    _c("div", { staticClass: "bj-formItemLabel" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "WarehouseManagement.form.isLogisticsSpecified"
                          )
                        )
                      ),
                    ]),
                    _c(
                      "div",
                      { staticClass: "bj-form-item-value" },
                      [
                        _c("el-switch", {
                          attrs: {
                            "active-color": "#082dc3",
                            "inactive-color": "",
                          },
                          on: { change: _vm.offSwitch },
                          model: {
                            value: _vm.info.isLogisticsSpecified,
                            callback: function ($$v) {
                              _vm.$set(_vm.info, "isLogisticsSpecified", $$v)
                            },
                            expression: "info.isLogisticsSpecified",
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              (_vm.orderInfoVO.shippingMethod == "CSG MANUAL" ||
                _vm.orderInfoVO.shippingMethod == "CUSTOMER MANUAL") &&
              _vm.info.isLogisticsSpecified
                ? _c("div", { staticClass: "bj-form-item" }, [
                    _c("div", { staticClass: "bj-formItemLabel" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("WarehouseManagement.form.chooseLogistics")
                        )
                      ),
                    ]),
                    _c(
                      "div",
                      { staticClass: "bj-form-item-value" },
                      [
                        _vm.operationType != 1
                          ? _c("span", { staticClass: "ellipsis" }, [
                              _vm._v(_vm._s(_vm.orderInfoVO.logisticsName)),
                            ])
                          : _c("BjSelectLov", {
                              attrs: {
                                "option-list": _vm.LogisticsSelectionData,
                                clearable: false,
                              },
                              on: { change: _vm.logsome },
                              model: {
                                value: _vm.orderInfoVO.logisticsName,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.orderInfoVO,
                                    "logisticsName",
                                    $$v
                                  )
                                },
                                expression: "orderInfoVO.logisticsName",
                              },
                            }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _c("div", { staticClass: "bj-form-item" }, [
                _c("div", { staticClass: "bj-formItemLabel" }, [
                  _vm._v(_vm._s(_vm.$t("BusinessPurchaseOrder2.means"))),
                ]),
                _c("div", { staticClass: "bj-form-item-value" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.orderInfoVO.shippingMethod !== "PICKUP" &&
                          _vm.info.isLogisticsSpecified &&
                          _vm.orderInfoVO.logisticsName
                          ? _vm.orderInfoVO.shippingMethod +
                              " (" +
                              _vm.orderInfoVO.logisticsName +
                              ")"
                          : _vm.orderInfoVO.shippingMethod
                      ) +
                      " "
                  ),
                ]),
              ]),
              [
                _c("div", { staticClass: "file" }, [
                  _c("div", { staticClass: "order-material-content" }, [
                    _c("div", { staticClass: "bj-formItemLabel" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("OrdinaryOrderMix.LogisticsTable.Supporting")
                        ) + ":"
                      ),
                    ]),
                    !_vm.isOrderMaterialEdit
                      ? _c(
                          "div",
                          { staticClass: "fileUpload" },
                          _vm._l(
                            _vm.info.orderInfoVO.orderMaterialList,
                            function (item, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "fileUpload_right" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "ellipsis link",
                                      on: {
                                        click: function ($event) {
                                          return _vm.downloadImageUrl(
                                            item.fileUrl,
                                            item.fileName
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          "file" + _vm._s(index + 1) + ": "
                                        ),
                                      ]),
                                      _vm._v(" " + _vm._s(item.fileName)),
                                    ]
                                  ),
                                ]
                              )
                            }
                          ),
                          0
                        )
                      : _c(
                          "div",
                          { staticClass: "fileUpload2 order-material-upload" },
                          [
                            _c(
                              "UploadFile",
                              {
                                ref: "UploadOrderMaterialRef",
                                staticClass: "avatar-uploader",
                                attrs: {
                                  limit: 20,
                                  "limit-size": 5 * 1024,
                                  multiple: "",
                                  "show-file-list": "",
                                  accept:
                                    "image/png,image/jpeg,.csv,.pdf,.doc,.docx,.xlsx",
                                  "accept-list": [
                                    "image/jpeg",
                                    "image/png",
                                    ".csv",
                                    ".pdf",
                                    ".doc",
                                    ".xlsx",
                                  ],
                                  "auto-upload": "",
                                  "limit-hide": "",
                                },
                                on: {
                                  handleFileListChange:
                                    _vm.fileListChangeOrderMaterial,
                                },
                              },
                              [
                                _c(
                                  "template",
                                  { slot: "default" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "small",
                                          type: "primary",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "BusinessImportHistory.page.SelectFile"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                  ]),
                  _c("div", { staticClass: "order-material-actions" }, [
                    _vm.$store.getters.cusId &&
                    !_vm.isOrderMaterialEdit &&
                    _vm.routeStatus != 4
                      ? _c(
                          "span",
                          {
                            staticClass: "link order-material-action",
                            on: { click: _vm.showOrderMaterialEdit },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("InternalSalesOrderDetails.Modify"))
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.isOrderMaterialEdit
                      ? _c(
                          "span",
                          {
                            staticClass: "link order-material-action",
                            on: { click: _vm.saveOrderMaterial },
                          },
                          [_vm._v(_vm._s(_vm.$t("saveText")))]
                        )
                      : _vm._e(),
                    _vm.isOrderMaterialEdit
                      ? _c(
                          "span",
                          {
                            staticClass: "link order-material-action",
                            on: { click: _vm.cancelOrderMaterialEdit },
                          },
                          [_vm._v(_vm._s(_vm.$t("cancelText")))]
                        )
                      : _vm._e(),
                  ]),
                ]),
              ],
            ],
            2
          ),
          _c("buyerInfoDialog", {
            attrs: {
              "receiver-info-v-o": _vm.info.receiverInfoVO,
              "is-show-edit":
                _vm.operationType == 1 ||
                (_vm.routeStatus === 8 &&
                  _vm.orderInfoVO.shippingMethod == "CSG MANUAL" &&
                  _vm.$route.query.type == "edit"),
            },
            on: { saveReceiverInfo: _vm.saveReceiverInfo },
          }),
        ],
        1
      ),
      [
        _c("BjDivider", { attrs: { id: "shippingLabel" } }, [
          _vm._v(
            " " +
              _vm._s(_vm.$t("InternalSalesOrderDetails.shippingLabel")) +
              " "
          ),
        ]),
        _c("div", { staticClass: "bj-row mt20" }, [
          _c(
            "div",
            { staticClass: "bj-col bj-col-12" },
            [
              _c("div", { staticClass: "bj-form-title" }, [
                _vm.info.orderInfoVO.shippingLabels &&
                _vm.info.orderInfoVO.shippingLabels.length > 0
                  ? _c(
                      "span",
                      {
                        staticClass: "link right",
                        staticStyle: { "margin-left": "10px" },
                        on: { click: _vm.batchDownLoad },
                      },
                      [_vm._v(_vm._s(_vm.$t("downloadText")))]
                    )
                  : _vm._e(),
                ((![4, 5, 7, 8].includes(_vm.routeStatus) &&
                  !_vm.isOrderInfoVOEdit &&
                  _vm.logisticsInfoObj.logisticsStatus != 2) ||
                  (_vm.routeStatus === 8 && _vm.$route.query.type == "edit")) &&
                _vm.orderInfoVO.shippingMethod === "CUSTOMER MANUAL"
                  ? _c(
                      "span",
                      {
                        staticClass: "link right",
                        staticStyle: { "margin-left": "10px" },
                        on: { click: _vm.showOrderInfoVOEdit },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("InternalSalesOrderDetails.Modify"))
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm.isOrderInfoVOEdit
                  ? _c(
                      "span",
                      {
                        staticClass: "link right",
                        staticStyle: { "margin-left": "10px" },
                        on: { click: _vm.saveShippingLabelInfo },
                      },
                      [_vm._v(_vm._s(_vm.$t("saveText")))]
                    )
                  : _vm._e(),
                _vm.isOrderInfoVOEdit
                  ? _c(
                      "span",
                      {
                        staticClass: "link right",
                        on: {
                          click: function ($event) {
                            _vm.isOrderInfoVOEdit = false
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("cancelText")))]
                    )
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "bj-form-item" }, [
                _c("div", { staticClass: "bj-formItemLabel" }, [
                  _vm._v(_vm._s(_vm.$t("BusinessPurchaseOrder2.means"))),
                ]),
                _c("div", { staticClass: "bj-form-item-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.orderInfoVO.shippingMethod))]),
                ]),
              ]),
              _vm.orderInfoVO.shippingMethod === "CSG MANUAL" ||
              _vm.orderInfoVO.shippingMethod === "CUSTOMER MANUAL"
                ? [
                    _c("div", { staticClass: "bj-form-item" }, [
                      _c("div", { staticClass: "bj-formItemLabel" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("WarehouseManagement.form.chooseLogistics")
                          )
                        ),
                      ]),
                      _c("div", { staticClass: "bj-form-item-value" }, [
                        _c(
                          "div",
                          { staticClass: "bj-col-12" },
                          [
                            !_vm.isOrderInfoVOEdit
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.logisticsInfoObj.logisticsBusinessName
                                    )
                                  ),
                                ])
                              : _c("BjSelectLov", {
                                  attrs: {
                                    "option-list": _vm.LogisticsSelectionData,
                                  },
                                  on: { change: _vm.changeLogistics },
                                  model: {
                                    value:
                                      _vm.logisticsInfoObj
                                        .logisticsBusinessName,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.logisticsInfoObj,
                                        "logisticsBusinessName",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "logisticsInfoObj.logisticsBusinessName",
                                  },
                                }),
                          ],
                          1
                        ),
                      ]),
                    ]),
                    _vm.orderInfoVO.shippingMethod === "CSG MANUAL"
                      ? _c("div", { staticClass: "bj-form-item" }, [
                          _c("div", { staticClass: "bj-formItemLabel" }, [
                            _vm._v(
                              _vm._s(_vm.$t("billingPage.Carrie")) +
                                _vm._s(
                                  _vm.$t(
                                    "BusinessOrderAuditComSkuList.transPrice"
                                  )
                                )
                            ),
                          ]),
                          _c("div", { staticClass: "bj-form-item-value" }, [
                            _c(
                              "div",
                              { staticClass: "bj-col-12" },
                              [
                                !_vm.isOrderInfoVOEdit
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.logisticsInfoObj.totalPrice)
                                      ),
                                    ])
                                  : _c("BjInputMoney", {
                                      attrs: { clearable: "" },
                                      model: {
                                        value: _vm.logisticsInfoObj.totalPrice,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.logisticsInfoObj,
                                            "totalPrice",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "logisticsInfoObj.totalPrice",
                                      },
                                    }),
                              ],
                              1
                            ),
                          ]),
                        ])
                      : _vm._e(),
                    _c("div", { staticClass: "bj-form-item" }, [
                      _c("div", { staticClass: "bj-formItemLabel" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "OrdinaryOrderMix.LogisticsTable.logisticsNo"
                            )
                          )
                        ),
                      ]),
                      _c("div", { staticClass: "bj-form-item-value" }, [
                        _c(
                          "div",
                          { staticClass: "bj-col-12" },
                          [
                            !_vm.isOrderInfoVOEdit
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.logisticsInfoObj.logisticsNo)
                                  ),
                                ])
                              : _c("BjInput", {
                                  attrs: { clearable: "" },
                                  model: {
                                    value: _vm.logisticsInfoObj.logisticsNo,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.logisticsInfoObj,
                                        "logisticsNo",
                                        $$v
                                      )
                                    },
                                    expression: "logisticsInfoObj.logisticsNo",
                                  },
                                }),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]
                : _vm._e(),
              [
                !_vm.isOrderInfoVOEdit
                  ? _c(
                      "div",
                      {
                        staticClass: "file",
                        staticStyle: { "line-height": "1.5" },
                      },
                      [
                        _c("div", { staticClass: "bj-formItemLabel" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("OrdinaryOrderMix.LogisticsTable.Shipment")
                            ) + ":"
                          ),
                        ]),
                        _c(
                          "div",
                          { staticClass: "fileUpload" },
                          _vm._l(
                            _vm.info.orderInfoVO.shippingLabels,
                            function (item, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "flex" },
                                [
                                  _c("span", [
                                    _vm._v("file" + _vm._s(index + 1) + ":"),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "ellipsis",
                                      staticStyle: { width: "350px" },
                                    },
                                    [_vm._v(_vm._s(item.name))]
                                  ),
                                ]
                              )
                            }
                          ),
                          0
                        ),
                      ]
                    )
                  : [
                      _c("div", { staticClass: "font12" }, [
                        _c("div", { staticClass: "bj-formItemLabel" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("OrdinaryOrderMix.LogisticsTable.Shipment")
                            ) + ":"
                          ),
                        ]),
                      ]),
                      _c(
                        "div",
                        { staticClass: "fileUpload2" },
                        [
                          _c(
                            "UploadFile",
                            {
                              ref: "UploadFileRef",
                              staticClass: "avatar-uploader",
                              attrs: {
                                limit: 20,
                                "limit-size": 5 * 1024,
                                multiple: "",
                                "show-file-list": "",
                                accept:
                                  "image/png,image/jpeg,.csv,.pdf,.doc,.docx,.xlsx",
                                "accept-list": [
                                  "image/jpeg",
                                  "image/png",
                                  ".csv",
                                  ".pdf",
                                  ".doc",
                                  ".xlsx",
                                ],
                                "auto-upload": "",
                                "limit-hide": "",
                              },
                              on: { handleFileListChange: _vm.fileListChange },
                            },
                            [
                              _c(
                                "template",
                                { slot: "default" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "small", type: "primary" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "BusinessImportHistory.page.SelectFile"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
              ],
            ],
            2
          ),
          _c("div", { staticClass: "bj-col bj-col-12" }, [
            _c("div", { staticClass: "bj-form-title" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("WarehouseManagement.form.chooseLogistics")) +
                  " "
              ),
            ]),
            _vm.orderInfoVO.shippingMethod == "CSG MANUAL"
              ? _c("div", { staticClass: "bj-form-item" }, [
                  _c("div", { staticClass: "bj-formItemLabel" }, [
                    _vm._v(
                      _vm._s(_vm.$t("WarehouseManagement.form.isQuotation"))
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "bj-form-item-value" },
                    [
                      _c("el-switch", {
                        attrs: {
                          disabled: "",
                          "active-color": "#082dc3",
                          "inactive-color": "",
                        },
                        model: {
                          value: _vm.orderInfoVO.isNeedQuota,
                          callback: function ($$v) {
                            _vm.$set(_vm.orderInfoVO, "isNeedQuota", $$v)
                          },
                          expression: "orderInfoVO.isNeedQuota",
                        },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm.orderInfoVO.shippingMethod == "CSG MANUAL"
              ? _c("div", { staticClass: "bj-form-item" }, [
                  _c("div", { staticClass: "bj-formItemLabel" }, [
                    _vm._v(_vm._s(_vm.$t("WarehouseManagement.form.amount"))),
                  ]),
                  _c("div", { staticClass: "bj-form-item-value" }, [
                    _c("div", { staticClass: "bj-form-item-value" }, [
                      _vm._v(_vm._s(_vm.orderInfoVO.quotedAmount) + " AUD"),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm.orderInfoVO.shippingMethod == "CSG MANUAL"
              ? _c("div", { staticClass: "bj-form-item" }, [
                  _c("div", { staticClass: "bj-formItemLabel" }, [
                    _vm._v(
                      _vm._s(_vm.$t("WarehouseManagement.form.quotationStatus"))
                    ),
                  ]),
                  _c("div", { staticClass: "bj-form-item-value" }, [
                    _c("div", { staticClass: "bj-form-item-value" }, [
                      _vm._v(
                        _vm._s(
                          _vm.quotationStatusList.bjGet(
                            _vm.orderInfoVO.quotaOrNot
                          )
                        )
                      ),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm.orderInfoVO.shippingMethod == "CUSTOMER MANUAL"
              ? _c("div", { staticClass: "bj-form-item" }, [
                  _c("div", { staticClass: "bj-formItemLabel" }, [
                    _vm._v(_vm._s(_vm.$t("WarehouseManagement.form.check"))),
                  ]),
                  _c(
                    "div",
                    { staticClass: "bj-form-item-value" },
                    [
                      _c("el-switch", {
                        attrs: {
                          disabled: "",
                          "active-color": "#082dc3",
                          "inactive-color": "",
                        },
                        model: {
                          value: _vm.orderInfoVO.isProvideSize,
                          callback: function ($$v) {
                            _vm.$set(_vm.orderInfoVO, "isProvideSize", $$v)
                          },
                          expression: "orderInfoVO.isProvideSize",
                        },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm.orderInfoVO.shippingMethod == "CUSTOMER MANUAL"
              ? _c("div", { staticClass: "bj-form-item" }, [
                  _c("div", { staticClass: "bj-formItemLabel" }, [
                    _vm._v(_vm._s(_vm.$t("WarehouseManagement.form.filled"))),
                  ]),
                  _c(
                    "div",
                    { staticClass: "bj-form-item-value" },
                    [
                      _c("el-switch", {
                        attrs: {
                          disabled: "",
                          "active-color": "#082dc3",
                          "inactive-color": "",
                        },
                        model: {
                          value: _vm.sizeIsFillIn,
                          callback: function ($$v) {
                            _vm.sizeIsFillIn = $$v
                          },
                          expression: "sizeIsFillIn",
                        },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm.orderInfoVO.shippingMethod == "CUSTOMER MANUAL" &&
            _vm.sizeIsFillIn
              ? _c("div", { staticClass: "bj-form-item" }, [
                  _c("div", { staticClass: "bj-formItemLabel" }, [
                    _vm._v(_vm._s(_vm.$t("WarehouseManagement.form.Length"))),
                  ]),
                  _c("div", { staticClass: "bj-form-item-value" }, [
                    _c("div", { staticClass: "bj-form-item-value" }, [
                      _vm._v(_vm._s(_vm.orderInfoVO.repLength) + " cm"),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm.orderInfoVO.shippingMethod == "CUSTOMER MANUAL" &&
            _vm.sizeIsFillIn
              ? _c("div", { staticClass: "bj-form-item" }, [
                  _c("div", { staticClass: "bj-formItemLabel" }, [
                    _vm._v(_vm._s(_vm.$t("WarehouseManagement.form.Width"))),
                  ]),
                  _c("div", { staticClass: "bj-form-item-value" }, [
                    _c("div", { staticClass: "bj-form-item-value" }, [
                      _vm._v(_vm._s(_vm.orderInfoVO.repWidth) + " cm"),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm.orderInfoVO.shippingMethod == "CUSTOMER MANUAL" &&
            _vm.sizeIsFillIn
              ? _c("div", { staticClass: "bj-form-item" }, [
                  _c("div", { staticClass: "bj-formItemLabel" }, [
                    _vm._v(_vm._s(_vm.$t("WarehouseManagement.form.Height"))),
                  ]),
                  _c("div", { staticClass: "bj-form-item-value" }, [
                    _c("div", { staticClass: "bj-form-item-value" }, [
                      _vm._v(_vm._s(_vm.orderInfoVO.repHeight) + " cm"),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm.orderInfoVO.shippingMethod == "CUSTOMER MANUAL" &&
            _vm.sizeIsFillIn
              ? _c("div", { staticClass: "bj-form-item" }, [
                  _c("div", { staticClass: "bj-formItemLabel" }, [
                    _vm._v(_vm._s(_vm.$t("WarehouseManagement.form.Weight"))),
                  ]),
                  _c("div", { staticClass: "bj-form-item-value" }, [
                    _c("div", { staticClass: "bj-form-item-value" }, [
                      _vm._v(_vm._s(_vm.orderInfoVO.repWeight) + " kg"),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm.orderInfoVO.shippingMethod == "CUSTOMER MANUAL"
              ? _c("div", { staticClass: "bj-form-item" }, [
                  _c("div", { staticClass: "bj-formItemLabel" }, [
                    _vm._v(_vm._s(_vm.$t("WarehouseManagement.form.need"))),
                  ]),
                  _c("div", { staticClass: "bj-form-item-value" }, [
                    _c("div", { staticClass: "bj-form-item-value" }, [
                      _vm._v(_vm._s(_vm.orderInfoVO.palletQty)),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm.orderInfoVO.shippingMethod == "CUSTOMER MANUAL"
              ? _c("div", { staticClass: "bj-form-item" }, [
                  _c("div", { staticClass: "bj-formItemLabel" }, [
                    _vm._v(_vm._s(_vm.$t("WarehouseManagement.form.time"))),
                  ]),
                  _c("div", { staticClass: "bj-form-item-value" }, [
                    _c("div", { staticClass: "bj-form-item-value" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("timeFilters")(
                            _vm.orderInfoVO.truckPickupTime,
                            _vm.orderInfoVO.truckPickupTime
                          )
                        )
                      ),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ]),
        ]),
      ],
      _vm.ImgData.length > 0
        ? _c("BjDivider", { attrs: { id: "imgInfo" } }, [
            _vm._v(_vm._s(this.$t("InternalSalesOrderDetails.Image")) + " "),
          ])
        : _vm._e(),
      _vm.ImgData.length > 0
        ? _c("div", { staticClass: "bj-row mt20" }, [
            _c(
              "div",
              { staticClass: "bj-col bj-col-24 flex-align relative" },
              [
                _vm._l(_vm.pdfData, function (item, key) {
                  return _c(
                    "div",
                    {
                      key: key,
                      staticStyle: {
                        position: "absolute",
                        top: "0",
                        left: "0",
                        "font-size": "14px",
                      },
                    },
                    [
                      _c(
                        "a",
                        {
                          staticStyle: { color: "#409eff" },
                          attrs: {
                            href: "" + item.detailImage,
                            target: "_blank",
                            download: "",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("downloadText") + "PDF"))]
                      ),
                    ]
                  )
                }),
                _vm._l(_vm.ImgData, function (item, key) {
                  return _c(
                    "div",
                    {
                      key: key,
                      staticStyle: { width: "22%", margin: "0 10px" },
                    },
                    [
                      item.imageType == "Signature" ||
                      item.imageType == "OrderPdf"
                        ? _c("BjKeyImage", {
                            attrs: {
                              width: "100%",
                              height: "120px",
                              url: "https://minio.wooper.com/test/10/1728874350587_14T9R1MV.png",
                              preview: "",
                            },
                          })
                        : _c("BjKeyImage", {
                            attrs: {
                              width: "100%",
                              height: "200px",
                              url: _vm.checkUrl(item.detailImage),
                              preview: "",
                            },
                          }),
                    ],
                    1
                  )
                }),
              ],
              2
            ),
          ])
        : _vm._e(),
      _c("BjDivider", { attrs: { id: "goodsInfo" } }, [
        _vm._v(_vm._s(this.$t("InternalSalesOrderDetails.Product")) + " "),
      ]),
      _c("div", { staticClass: "bj-row mt20" }, [
        _c(
          "div",
          { staticClass: "bj-col bj-col-24" },
          [
            _vm.tabVisible
              ? _c("GoodsInfoTab", {
                  ref: "GoodsInfoTab",
                  attrs: {
                    "order-id": _vm.id,
                    "inner-order-no": _vm.orderInfoVO.innerOrderNo,
                    "order-status": _vm.orderInfoVO.orderStatus,
                    "has-btn": "",
                    "business-type": _vm.businessType,
                  },
                  on: {
                    reFresh: _vm.reFresh,
                    afterFetchOriginalData: _vm.afterFetchOriginalData,
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      [
        _c("BjDivider", { attrs: { id: "logisticsInfo" } }, [
          _vm._v(_vm._s(this.$t("InternalSalesOrderDetails.Logistics")) + " "),
        ]),
        _c(
          "div",
          { staticClass: "bj-row mt20" },
          [
            _c("LogisticsTable", {
              ref: "LogisticsInfo",
              attrs: { "has-btn": "", "data-info": _vm.info },
            }),
          ],
          1
        ),
      ],
      _c("EditRemarks", {
        ref: "EditRemarks",
        attrs: { id: _vm.id, info: _vm.orderInfoVO },
        on: { editBaseInfoApi: _vm.editBaseInfoApi },
      }),
      _c("EditReceiverInfo", {
        ref: "EditReceiverInfo",
        attrs: { id: _vm.id, info: _vm.info.receiverInfoVO },
        on: { editBaseInfoApi: _vm.editBaseInfoApi },
      }),
      _c("SuspendReason", {
        ref: "SuspendReason",
        attrs: { id: _vm.id },
        on: { reFresh: _vm.reFresh },
      }),
      _c("EditTags", {
        ref: "EditTags",
        attrs: { id: _vm.id, tags: _vm.cptOrderTagCodeList },
        on: { editBaseInfoApi: _vm.editBaseInfoApi },
      }),
      _c(
        "BjDialog",
        {
          attrs: {
            title: _vm.$t("routeBusinessStockDeliveryInformView.business"),
            visible: _vm.logistics_visible,
            width: "600px",
          },
          on: {
            close: function ($event) {
              _vm.logistics_visible = false
            },
          },
        },
        [
          _c("bj-table", {
            ref: "BjTable",
            attrs: {
              loading: false,
              list: _vm.dialogListConfig.columns,
              serial: true,
              "is-pagination": false,
            },
            scopedSlots: _vm._u([
              {
                key: "tableColumn",
                fn: function () {
                  return [
                    _vm._l(_vm.dropCols, function (col, index) {
                      return [
                        col.prop !== "bjTableAction"
                          ? _c("el-table-column", {
                              key:
                                "col_" +
                                index +
                                "_" +
                                col.prop +
                                "_" +
                                (col.width || "auto"),
                              attrs: {
                                prop: col.prop,
                                label: col.label,
                                width: col.width || "auto",
                                fixed: col.fixed || false,
                                align: "center",
                                "class-name": "item",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var row = ref.row
                                      return [
                                        false
                                          ? void 0
                                          : col.prop === "isEnable"
                                          ? _c("el-switch", {
                                              attrs: { disabled: "" },
                                              model: {
                                                value: row[col.prop],
                                                callback: function ($$v) {
                                                  _vm.$set(row, col.prop, $$v)
                                                },
                                                expression: "row[col.prop]",
                                              },
                                            })
                                          : _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("timeFilters")(
                                                    row[col.prop],
                                                    row[col.prop]
                                                  )
                                                )
                                              ),
                                            ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            })
                          : _vm._e(),
                      ]
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("routeBusinessStockDeliveryInformView.go"),
            visible: _vm.isShow,
            width: "500px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShow = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "flex-align" },
            _vm._l(_vm.viewData, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  on: {
                    click: function ($event) {
                      return _vm.goThirdView(item)
                    },
                  },
                },
                [
                  _c("el-link", { attrs: { type: "primary" } }, [
                    _vm._v(_vm._s(item)),
                  ]),
                  _vm.viewData.length - 1 != index
                    ? _c("span", { staticStyle: { color: "black" } }, [
                        _vm._v("，"),
                      ])
                    : _vm._e(),
                ],
                1
              )
            }),
            0
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.isShow = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("cancelText")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.goCopyPage()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("InternalSalesOrderDetails.Resend")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }